module.exports = __webpack_public_path__ + "img/a5-s22.f7ba26ec.jpg";